var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"lg":"6"}},[_c('CCard',[_c('CCardHeader',[_vm._v("Bar Chart")]),_c('CCardBody',[_c('CChartBarExample')],1)],1)],1),_c('CCol',{attrs:{"lg":"6"}},[_c('CCard',[_c('CCardHeader',[_vm._v("Doughnut Chart")]),_c('CCardBody',[_c('CChartDoughnutExample')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }